export default __webpack_public_path__ + "static/media/Play1.6cb3a8bf.png";